import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';

import { Breakpoint, SpacingRecord } from '../../theme/type';
import { colorToCss } from '../../theme/utils';
import { getMargin, getPadding } from '../../utils/spacing';
import { SectionProps } from './type';

const PADDING_FALLBACK: SpacingRecord = {
  x: { md: '1.25rem', xs: '1rem' },
  y: { md: '2.5rem', xs: '1.75rem' },
};

const Section: FC<SectionProps> = ({
  background,
  children,
  className,
  margin,
  maxW = Breakpoint.XL,
  padding,
}) => {
  const sx = useDeepCompareMemo<SxProps<Theme>>(
    () => ({
      ...getPadding(padding, PADDING_FALLBACK),
      ...getMargin(margin),
      backgroundColor: colorToCss(background),
    }),
    [margin, padding, background]
  );

  return (
    <Box className={className} component='section' sx={sx}>
      <Container maxWidth={maxW}>{children}</Container>
    </Box>
  );
};

export default Section;
